// extracted by mini-css-extract-plugin
export default {"header":"Header_header__d+igc","link__wrapper":"Header_link__wrapper__vAadc","link":"Header_link__+IYA6"};